// extracted by mini-css-extract-plugin
module.exports = {"NotAvailable":"JobFileName_NotAvailable__v2c+t"};